var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$props.status.trim() !== 'NONE')?_c('span',{directives:[{name:"t",rawName:"v-t",value:(("Orders." + _vm._correctState)),expression:"`Orders.${ _correctState }`"}],class:_vm.ordersStatus.css}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ece4278","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/miscellaneous/OrdersStatus.vue
// module id = null
// module chunks = 